export default __webpack_public_path__ + "static/why-choose-2d7b7c9aba4eeb26c956eb336050fc21.png";